import React from "react";
import { Control, Controller } from "react-hook-form";
import InspectionTimeDropdown, {
  InspectionTimeDropdownProps,
  InspectionTimeDropdownOption,
} from "./InspectionTimeDropdown";

export interface ControlledInspectionTimeDropdownProps<T = InspectionTimeDropdownOption> {
  name: string;
  control: Control;
  transform?: {
    input: (value: T | null) => InspectionTimeDropdownOption | null;
    output: (value: InspectionTimeDropdownOption | null) => T | null;
  };
  inspectionTimeDropdownProps?: Omit<InspectionTimeDropdownProps, "value" | "onChange">;
}
export default function ControlledInspectionTimeDropdown<T = InspectionTimeDropdownOption>({
  name,
  control,
  inspectionTimeDropdownProps,
  transform,
}: ControlledInspectionTimeDropdownProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ value, onChange }) => {
        const handleChange = (value: InspectionTimeDropdownOption | null) => {
          const transformedValue = transform?.output ? transform.output(value) : value;
          onChange(transformedValue);
        };
        const transformedValue = transform?.input ? transform.input(value) : value;
        return (
          <InspectionTimeDropdown {...inspectionTimeDropdownProps} value={transformedValue} onChange={handleChange} />
        );
      }}
    />
  );
}
